import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import 'jspdf-autotable';
import offerLetter from '../pdf/OfferLetter.pdf';
import { saveAs } from 'file-saver';
import { removeBracketedText } from '../Axiosinstance';
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import fontkit from '@pdf-lib/fontkit';

// import { removeBracketedText } from '../Axiosinstance';
import calibriFontBold from '../fonts/CalibriBold.ttf'
import calibriFont from '../fonts/calibri.ttf'


const AdmissionOffer = forwardRef(({ dataProp }, ref) => {


  const handleDownload = async () => {
    const pdfBytes = await fetch(offerLetter).then((res) => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(pdfBytes);
    const pages = pdfDoc.getPages();
    const firstPage = pages[0];
    const secondPage = pages[1];
    const thirdPage = pages[2];
    const fourtPage = pages[4]; //actually this is fifth page , fourth is empty
    pdfDoc.registerFontkit(fontkit);



    const monthsDifference = dataProp?.type === 'diploma' ? 12 : dataProp?.type === 'advance_diploma' ? 6 : 0;


    const helveticaBoldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
    const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);

    const calibriFontBoldBytes = await fetch(calibriFontBold).then((res) => res.arrayBuffer());
    const calibriFontBoldEmbed = await pdfDoc.embedFont(calibriFontBoldBytes);

    const calibriBytes = await fetch(calibriFont).then((res) => res.arrayBuffer());
    const calibriFontEmbed = await pdfDoc.embedFont(calibriBytes);

    const studentName = (dataProp?.student.fullname || '').toUpperCase();
    const nric = dataProp?.student.nric || '';
    const course = (dataProp?.batch.course || '').toUpperCase().replace(/\s*\(1\)$/, '');

    const courseDuration = dataProp?.type === 'diploma' ? '12 Months ' : dataProp?.type === 'advance_diploma' ? '6 Months' : '';
    //FOR THE RENDERING LOGIC
    const dateforrender = dataProp?.scheduleDate[0]?.startDate;
    const courseFeeDate = dataProp?.courseFeeDetails?.[0]?.sessionDate;
    // const commencementDatetitle = formatDateWithOrdinal(dataProp.late ? dateforrender : extractDate(dataProp?.paidDate));
    const commencementDatetitle = formatDateWithOrdinal(
      dataProp.late ? dateforrender : extractDate(courseFeeDate)
    );

    console.log("formatted", commencementDatetitle);
    console.log("without", dateforrender);

    const commencementDate = formatDateWithOrdinal(dataProp?.scheduleDate[0]?.startDate);
    console.log("comm", commencementDate);
    const completiondatefinal = calculateCompletionDate(dataProp?.scheduleDate[0]?.startDate, dataProp?.type);
    const completionDate = formatDateWithOrdinal(completiondatefinal);
    const courseFees = `$${dataProp?.courseFee || 0}`;
    const courseFeesBold = `${dataProp?.courseFee || 0}`;
    const taxDeductedCourseFees = `$${dataProp?.courseFee - 150 || 0}`;
    // const venue = (dataProp?.batch.venue || '').toUpperCase();
    const venue = dataProp?.batch?.venue || '';
    const materialfees = "$150";

    const approver = (dataProp?.approver).toUpperCase() || '';




    const isCommencementSingleDigit = formatDateWithDigit(dataProp?.scheduleDate[0]?.startDate);
    const isCompletionSingleDigit = formatDateWithDigit(completionDate);


    const parts = commencementDate.split(' ');
    const commencementDatesmall = parts.map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()).join(' ');

    const partstitle = commencementDatetitle.split(' ');
    const joiningdate = partstitle.map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()).join(' ');

    //for date
    const xfirstcom = formatDateWithDigit(joiningdate) ? 71 : 71;  // Adjust the horizontal position
    const yfirstcom = formatDateWithDigit(joiningdate) ? 750 : 750; // Adjust the vertical position
    const fontSizefirstcom = formatDateWithDigit(joiningdate) ? 11 : 11;




    const xsecondcom = isCommencementSingleDigit ? 258 : 278.8;  // Adjust the horizontal position
    const ysecondcom = isCommencementSingleDigit ? 596.5 : 596.5; // Adjust the vertical position
    const fontSizesecondcom = isCommencementSingleDigit ? 10 : 10;


    const xthirdcom = isCommencementSingleDigit ? 258 : 278.8;  // Adjust the horizontal position
    const ythirdcom = isCommencementSingleDigit ? 581 : 581; // Adjust the vertical position
    const fontSizethirdcom = isCommencementSingleDigit ? 10 : 10;

    const getTextWidth = (text, font, fontSize) => {
      const width = font.widthOfTextAtSize(text, fontSize);
      return width;
    };

    console.log(joiningdate, "join")

    const drawWrappedTitle = async (page, text, x, y, font, fontSize, maxWidth) => {
      if (!text) return;
      const lines = [];
      let currentLine = '';
      const words = text.split(' ');

      for (let i = 0; i < words.length; i++) {
        const word = words[i];
        const width = getTextWidth(currentLine + ' ' + word, font, fontSize);

        if (width < maxWidth) {
          currentLine += (currentLine === '' ? '' : ' ') + word;
        } else {
          lines.push(currentLine.trim());
          currentLine = word;
        }
      }

      if (currentLine !== '') {
        lines.push(currentLine.trim());
      }

      for (let i = 0; i < lines.length; i++) {
        const line = lines[i].trim();
        const lineWidth = getTextWidth(line, font, fontSize);

        await page.drawText(line, {
          x: i === 0 ? x : x,  // Keep the initial X position for all lines
          y: y - i * 11,       // Adjust the line height as needed
          size: fontSize,
          font,
          color: rgb(0, 0, 0),
        });
      }
      return lines.length * 11; // Return the height of the wrapped text
    };


    //for th ,nd
    const ordinalSuffixtitle = extractDayFromFormattedDate(joiningdate);
    const xPos = formatDateWithDigit(joiningdate) ? 77 : 83;  // Adjust the horizontal position
    const yPos = formatDateWithDigit(joiningdate) ? 755 : 755; // Adjust the vertical position
    const fontSize = formatDateWithDigit(joiningdate) ? 7 : 7;  // Adjust the font size

    // const extractdate = getDayFromDateString(commencementDate);
    const ordinalSuffixFirst = extractDayFromFormattedDate(commencementDate);
    // const xfirst = isCommencementSingleDigit ? 262.5 : 268.5;  // Adjust the horizontal position
    // const yfirst = isCommencementSingleDigit ? 602 : 602;  // Adjust the vertical position
    // const fontSizefirst = isCommencementSingleDigit ? 6 : 6;  // Adjust the font size


    const ordinalSuffixcomplete = extractDayFromFormattedDate(completionDate);
    // const xcomplete = isCompletionSingleDigit ? 263.5 : 269;  // Adjust the horizontal position
    // const ycomplete = isCompletionSingleDigit ? 586 : 586;  // Adjust the vertical position
    // const fontSizecomplete = isCompletionSingleDigit ? 6 : 6;  // Adjust the font size


    const ordinalSuffixlast = extractDayFromFormattedDate(joiningdate);
    const xlast = formatDateWithDigit(joiningdate) ? 78 : 83; // Adjust the horizontal position
    const ylast = formatDateWithDigit(joiningdate) ? 241 : 241;  // Adjust the vertical position
    const fontSizelast = formatDateWithDigit(joiningdate) ? 6 : 6;  // Adjust the font size


    //title
    drawWrappedTitle(firstPage, removeBracketedText(course), 184.5, 693.8, helveticaBoldFont, 9, 322);
    // firstPage.drawText(course, { x: 184.5, y: 693.8, size: 10, font: helveticaBoldFont, color: rgb(0, 0, 0) });
    firstPage.drawText(`${joiningdate}`, { x: 71, y: 750, size: 11, color: rgb(0, 0, 0) }); // Remove ${ordinalSuffix} here
    firstPage.drawText(`${ordinalSuffixtitle}`, { x: xPos, y: yPos, size: fontSize, color: rgb(0, 0, 0) });


    fourtPage.drawText(`${ordinalSuffixlast}`, { x: xlast, y: ylast, size: fontSizelast, color: rgb(0, 0, 0) });

    // firstPage.drawText("Course Name                            :", { x: 110, y: 627.5, size: 9.7,  font: helveticaBoldFont,color: rgb(0, 0, 0)  });
    // firstPage.drawText("Course Duration                       :", { x: 110, y: 612, size: 9.7,  font: helveticaBoldFont,color: rgb(0, 0, 0)  });
    // firstPage.drawText("Commencement Date              :", { x: 110, y: 596.5, size: 9.7,  font: helveticaBoldFont,color: rgb(0, 0, 0)  });
    // firstPage.drawText("Expected Date of Completion :", { x: 110, y: 581, size: 9.7,  font: helveticaBoldFont,color: rgb(0, 0, 0)  });
    // firstPage.drawText("Venue                                         :", { x: 110, y: 565.8, size: 9.7,  font: helveticaBoldFont,color: rgb(0, 0, 0)  });

    const wrappedTitleHeight = await drawWrappedTitle(firstPage, removeBracketedText(course), 258, 627.5, helveticaFont, 10, 322);

    // Adjust y positions based on wrappedTitleHeight
    const adjustedYForTitle = 627.5;
    const adjustedYForDuration = adjustedYForTitle - wrappedTitleHeight - 8;
    const adjustedYForCommencement = adjustedYForDuration - 15;
    const adjustedYForCompletion = adjustedYForCommencement - 15;
    const adjustedYForVenue = adjustedYForCompletion - 15;

    // Draw the labels
    firstPage.drawText("Course Name", { x: 110, y: adjustedYForTitle, size: 9.7, font: helveticaBoldFont, color: rgb(0, 0, 0) });
    firstPage.drawText("Course Duration", { x: 110, y: adjustedYForDuration, size: 9.7, font: helveticaBoldFont, color: rgb(0, 0, 0) });
    firstPage.drawText("Commencement Date", { x: 110, y: adjustedYForCommencement, size: 9.7, font: helveticaBoldFont, color: rgb(0, 0, 0) });
    firstPage.drawText("Expected Date of Completion", { x: 110, y: adjustedYForCompletion, size: 9.7, font: helveticaBoldFont, color: rgb(0, 0, 0) });
    firstPage.drawText("Venue", { x: 110, y: adjustedYForVenue, size: 9.7, font: helveticaBoldFont, color: rgb(0, 0, 0) });

    // Draw the colons
    firstPage.drawText(":", { x: 253, y: adjustedYForTitle, size: 9.7, font: helveticaBoldFont, color: rgb(0, 0, 0) });
    firstPage.drawText(":", { x: 253, y: adjustedYForDuration, size: 9.7, font: helveticaBoldFont, color: rgb(0, 0, 0) });
    firstPage.drawText(":", { x: 253, y: adjustedYForCommencement, size: 9.7, font: helveticaBoldFont, color: rgb(0, 0, 0) });
    firstPage.drawText(":", { x: 253, y: adjustedYForCompletion, size: 9.7, font: helveticaBoldFont, color: rgb(0, 0, 0) });
    firstPage.drawText(":", { x: 253, y: adjustedYForVenue, size: 9.7, font: helveticaBoldFont, color: rgb(0, 0, 0) });

    // Draw the values
    // firstPage.drawText(removeBracketedText(course), { x: 258, y: adjustedYForTitle, size: 10, font: helveticaFont, color: rgb(0, 0, 0) });
    firstPage.drawText(courseDuration, { x: 258, y: adjustedYForDuration, size: 10, font: helveticaFont, color: rgb(0, 0, 0) });
    firstPage.drawText(commencementDate, { x: 258, y: adjustedYForCommencement, size: 10, font: helveticaFont, color: rgb(0, 0, 0) });
    firstPage.drawText(completionDate, { x: 258, y: adjustedYForCompletion, size: 10, font: helveticaFont, color: rgb(0, 0, 0) });
    firstPage.drawText(venue, { x: 258, y: adjustedYForVenue, size: 10, font: helveticaFont, color: rgb(0, 0, 0) });

    // Adjust positions for ordinal suffixes
    const xcommen = isCommencementSingleDigit ? 262.9 : 268.5;
    const ycommen = adjustedYForCommencement + 4; // Adjust based on height
    const fontSizecommen = isCommencementSingleDigit ? 6 : 6;

    const xcompletedate = isCompletionSingleDigit ? 263.5 : 269;
    const ycompletedate = adjustedYForCompletion + 4; // Adjust based on height
    // const fontSizecomplete = isCompletionSingleDigit ? 6 : 6;

    // Draw ordinal suffixes
    firstPage.drawText(`${ordinalSuffixFirst.toUpperCase()}`, { x: xcommen, y: ycommen, size: fontSizecommen, color: rgb(0, 0, 0) });
    firstPage.drawText(`${ordinalSuffixcomplete.toUpperCase()}`, { x: xcompletedate, y: ycompletedate, size: fontSizecommen, color: rgb(0, 0, 0) });

    // if (ordinalSuffixFirst) {
    //   firstPage.drawText(ordinalSuffixFirst, { x: xfirst, y: yfirst, size: fontSizefirst, font: helveticaFont, color: rgb(0, 0, 0) });
    // }
    // if (ordinalSuffixcomplete) {
    //   firstPage.drawText(ordinalSuffixcomplete, { x: xcomplete, y: ycomplete, size: fontSizecomplete, font: helveticaFont, color: rgb(0, 0, 0) });
    // }
    // if (ordinalSuffixtitle) {
    //   firstPage.drawText(ordinalSuffixtitle, { x: xPos, y: yPos, size: fontSize, font: helveticaFont, color: rgb(0, 0, 0) });
    // }
    // if (ordinalSuffixlast) {
    //   firstPage.drawText(ordinalSuffixlast, { x: xlast, y: ylast, size: fontSizelast, font: helveticaFont, color: rgb(0, 0, 0) });
    // }
    secondPage.drawText(approver, { x: 72, y: 568, size: 11, color: rgb(0, 0, 0), font: helveticaBoldFont });

    thirdPage.drawText(taxDeductedCourseFees.toString(), { x: 427, y: 632, size: 11, color: rgb(0, 0, 0) });
    thirdPage.drawText(materialfees.toString(), { x: 429, y: 548, size: 11, color: rgb(0, 0, 0) });
    thirdPage.drawText(courseFeesBold.toString(), { x: 427, y: 491, size: 11, font: helveticaBoldFont, color: rgb(0, 0, 0) });
    thirdPage.drawText(monthsDifference.toString(), { x: 435, y: 464, size: 11, font: helveticaBoldFont, color: rgb(0, 0, 0) });
    thirdPage.drawText(courseFees.toString(), { x: 315, y: 111, size: 11, color: rgb(0, 0, 0) });




    // Calculate the width of the text to be drawn
    const textWidth = helveticaBoldFont.widthOfTextAtSize(studentName, 11);


    // Calculate the starting x-coordinate to ensure text starts from the left side of x: 218
    const startX = 178 - textWidth / 2; // Adjust as per your requirement

    const fullName = studentName;
    const placeStartX = 104;  // where blank line starts
    const placeEndX = 350;  // where blank line ends
    const placeWidth = placeEndX - placeStartX;
    const fontSizee = 11;
    const maxWidth = 350;
    const startY = 508;
    // split into max 2 lines ONLY if needed
    let line1 = fullName;
    let line2 = "";
    while (calibriFontBoldEmbed.widthOfTextAtSize(line1, fontSizee) > maxWidth) {
      const lastSpace = line1.lastIndexOf(" ");
      line2 = line1.substring(lastSpace + 1) + (line2 ? " " + line2 : "");
      line1 = line1.substring(0, lastSpace);
    }
    // ---- draw line 1 ----
    const line1Width =
      calibriFontBoldEmbed.widthOfTextAtSize(line1, fontSizee);
    fourtPage.drawText(line1, {
      x: placeStartX + (placeWidth - line1Width) / 2, // ✅ centered in place
      y: startY,
      size: fontSizee,
      font: calibriFontBoldEmbed,
    });
    // ---- draw line 2 ONLY if exists ----
    if (line2) {
      const line2Width =
        calibriFontBoldEmbed.widthOfTextAtSize(line2, fontSizee);
      fourtPage.drawText(line2, {
        x: placeStartX + (placeWidth - line2Width) / 2, // ✅ centered in place
        y: startY - 12,
        size: fontSizee,
        font: calibriFontBoldEmbed,
      });
    }

    // Draw the text
    // fourtPage.drawText(studentName, { x: startX, y: 496, size: 11, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
    // fourtPage.drawText(studentName, { x: 218, y: 496, size: 11, font: helveticaBoldFont, color: rgb(0, 0, 0) });
    fourtPage.drawText(nric, { x: 142, y: 480, size: 11, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
    fourtPage.drawText(joiningdate, { x: 73, y: 237, size: 9, color: rgb(0, 0, 0) });

    const removebracket = removeBracketedText(course);
    const techname = `${removebracket} at JURONG ACADEMY PTE LTD`;

    drawWrappedText(fourtPage, techname, 368, 478.5, 145, 72, 600, helveticaFont, 10, rgb(0, 0, 0));


    // For installment table
    let yPositionpayent = 329; // Start position for the first schedule entry
    const lineHeightpaymet = 15;
    const height = 15;
    let yPosition = 335;
    // Adjust the horizontal position


    if (monthsDifference > 0) {
      const courseFees = dataProp?.courseFee || 0;
      const installmentAmount = Math.round(courseFees / monthsDifference); // Removed decimal values by rounding


      for (let i = 1; i <= monthsDifference; i++) {
        const dueDate = new Date(dataProp?.scheduleDate[0].startDate); // Start with the first course date
        dueDate.setMonth(dueDate.getMonth() + i - 1); // Move i-1 months from the start
        dueDate.setDate(15); // Set the due date to the 15th of the month


        // Adjust the vertical position
        let xPosition = (i <= 9) ? 88 : 95;
        // console.log(yPosition);
        const formattedDueDate = formatDate(dueDate);


        const ordinalSuffix = getOrdinalSuffix(i); // Function to get the ordinal suffix (st, nd, rd, th)
        const installmentText = `${i} ${' '} instalment`;
        const installmentAmounttext = ` $${Math.round(installmentAmount)}`;
        const installmentDate = `${formattedDueDate}`;
        thirdPage.drawText(installmentText, { x: 82, y: yPositionpayent, size: 12, color: rgb(0, 0, 0) });
        thirdPage.drawText(ordinalSuffix, { x: xPosition, y: yPosition, size: 5, color: rgb(0, 0, 0) });
        thirdPage.drawText(installmentAmounttext, { x: 311, y: yPositionpayent, size: 12, color: rgb(0, 0, 0) });
        thirdPage.drawText(installmentDate, { x: 432.5, y: yPositionpayent, size: 12, color: rgb(0, 0, 0) });


        yPosition -= height;
        yPositionpayent -= lineHeightpaymet; // Move down for the next entry
        // console.log(yPosition);
        // console.log(yPositionpayent);


      }
    }


    // const pdfBytesEdited = await pdfDoc.save();
    // const blob = new Blob([pdfBytesEdited], { type: 'application/pdf' });
    // saveAs(blob, `${studentName}-OFFER-LETTER.pdf`);

    const pdfBytesModified = await pdfDoc.save();
    const pdfBlob = new Blob([pdfBytesModified], { type: 'application/pdf' });
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl, '_blank');
  };


  useImperativeHandle(ref, () => ({
    handleDownload,
  }));

  //FOR LAST page
  const drawWrappedText = (page, text, xFirst, y, maxWidthFirst, xSubsequent, maxWidthSubsequent, font, fontSize, color) => {
    const lines = [];
    let currentLine = '';
    let words = text.split(' ');

    while (words.length > 0) {
      let word = words.shift();
      let testLine = currentLine + word + ' ';
      let testWidth = font.widthOfTextAtSize(testLine, fontSize);

      if (testWidth <= (lines.length === 0 ? maxWidthFirst : maxWidthSubsequent)) {
        currentLine = testLine;
      } else {
        lines.push(currentLine.trim());
        currentLine = word + ' ';
      }
    }
    lines.push(currentLine.trim());

    // Draw lines
    lines.forEach((line, index) => {
      page.drawText(line, {
        x: index === 0 ? xFirst : xSubsequent,
        y: y - (index * fontSize * 1.2),
        size: fontSize,
        font: font,
        color: color
      });
    });
  };


  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return date.toLocaleDateString('en-GB', options);
  };


  const extractDate = (dateStr) => {
    const date = new Date(dateStr);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };




  function calculateCompletionDate(dateforcomplete, type) {
    const commencement = new Date(dateforcomplete);
    let completion;

    if (type === 'diploma') {
      // Add 1 year (minus 1 day) to commencement date
      completion = new Date(commencement);
      completion.setFullYear(commencement.getFullYear() + 1);
      completion.setDate(completion.getDate() - 1);
    } else if (type === 'advance_diploma') {
      // Add 6 months (minus 1 day) to commencement date
      completion = new Date(commencement);
      completion.setMonth(commencement.getMonth() + 6);
      completion.setDate(completion.getDate() - 1);
    } else {
      // Handle other types if necessary
      completion = commencement; // Default to the commencement date
    }

    return completion.toISOString().split('T')[0]; // Format as YYYY-MM-DD
  }


  //for title only
  function titleSuffix(day) {
    if (day >= 11 && day <= 13) {
      return 'th'; // Special case for 11th, 12th, 13th
    }
    switch (day % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  }

  const formatDateWithOrdinal = (dateStr) => {
    const date = new Date(dateStr);
    const day = date.getDate();
    const month = date.toLocaleString('en-GB', { month: 'long' }).toUpperCase();
    const year = date.getFullYear();
    // const ordinalSuffix = getOrdinalMonth(day);
    return `${day} ${' '} ${month} ${year}`;
  };


  const formatDateWithDigit = (dateStr) => {
    const date = new Date(dateStr);
    const day = date.getDate();
    const month = date.toLocaleString('en-GB', { month: 'long' }).toUpperCase();
    const year = date.getFullYear();
    // const ordinalSuffix = getOrdinalMonth(day);
    let isCommencementSingleDigit;
    if (isCommencementSingleDigit = day <= 9) {
      return true;
    } else {
      return false
    }
  };







  if (!dataProp) {
    return <div>Loading...</div>;
  }


  const firstDate = new Date(dataProp.scheduleDate[0].startDate);
  const lastDate = new Date(dataProp.scheduleDate[dataProp.scheduleDate.length - 1].endDate);
  const monthsDifference = (lastDate.getFullYear() - firstDate.getFullYear()) * 12 + lastDate.getMonth() - firstDate.getMonth() + 1;


  const courseCompletionDate = new Date(firstDate);
  courseCompletionDate.setFullYear(courseCompletionDate.getFullYear() + 1);
  courseCompletionDate.setDate(courseCompletionDate.getDate() - 1);


  const getOrdinalSuffix = (number) => {
    if (number === 1 || number === 21 || number === 31) {
      return 'st';
    } else if (number === 2 || number === 22) {
      return 'nd';
    } else if (number === 3 || number === 23) {
      return 'rd';
    } else {
      return 'th';
    }
  };


  const extractDayFromFormattedDate = (formattedDate) => {
    // Extract the day from the formatted date string
    const day = parseInt(formattedDate.split(' ')[0], 10);
    return forCommencement(day);
  };

  const forCommencement = (day) => {
    if (day > 3 && day < 21) return 'th'; // Handles the 'teen' numbers 11, 12, 13
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  };

  return null;
});


export default AdmissionOffer;





